module.exports = __webpack_public_path__ + "static/media/fundrise.d26b7ed4.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/companies/fundrise.png
 ** module id = 427
 ** module chunks = 0
 **/